<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-format-list-text</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.iconList') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/> -->
      <!-- <span style="color:rgba(0, 0, 0, 0.54);">{{$t('instagram.instagramIframe')}}</span> -->
      <!-- <v-text-field
        v-model="instagramIframe"
        append-icon="mdi-search"
        hideDetails
        single-line
        style="margin-left: 15px;"
        @input="handleSetInstagramIframe"
      /> -->
    </v-toolbar>
    <div 
      style="padding: 0 10px 10px 10px;" 
      v-show="!collapseContent"
    >
      <select-image
        v-model="content.IconListImage"
        :isFullWidth="false"
        :enterpriseID="enterpriseID"
        :imageOld='content.IconListImage'
        :imageWidth="200"
        :imageHeight="200"
        :aspectRatio="1/1"
        @input="handleChangeIsModified"
        style="margin-left:0px;margin-top:15px;margin-right: 0px;"
        width="100px"
      />
      <translate
        type="text"
        v-model="content.IconListTitle"
        :languages="languages"
        :label="$t('iconList.title')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
      <translate
        v-show="!collapseContent"
        type="text"
        v-model="content.IconListDescription"
        :languages="languages"
        :label="$t('iconList.description')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import SelectImage from '@/components/SelectImage'
  import Translate from '@/components/Translate'
  export default {
    components: {
      SelectImage,
      Translate,
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      instagramIframe: ''
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
    },
    created () {
      this.handleSetInstagramIframe = _.debounce(() => {
        this.onSetInstagramIframet(this.instagramIframe)
      }, 500)
    },
    mounted() {
      this.instagramIframe = this.content.InstagramIframe
    },
    methods: {
      onSetInstagramIframet() {
        this.content.instagramIframe = ''
        const that = this
        setTimeout(function(){
            that.content.InstagramIframe = that.instagramIframe
        }, 500);
        
        this.handleChangeIsModified
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

